module.exports = __webpack_public_path__ + "static/media/full-modal-header-mobile.bc290191.png";